<div
    class="wrapper"
    *ngIf="NewSwimLanes as swimLanes"
    cdkDropListGroup
>
    <ng-container *ngFor="let lane of swimLanes; let i = index; trackBy: TrackLanes">
        <!-- MDQX: Angezeigte Spalten werden basierend auf "SelectedBoardColumns" festgelegt -->
        <div class="swimLane" *ngIf="filterLanes(lane)" [class.collapsed]="isLaneCollapsed(lane.Id)">
            <h4 class="swim-lane-header" [class.clickable]="openedFromWeekPlan" (click)="toggleLaneCollapsed(lane.Id)">
                <fa-icon *ngIf="openedFromWeekPlan" icon="chevron-down" class="collapse-icon" [class.collapsed]="isLaneCollapsed(lane.Id)"></fa-icon>
                <span>{{ lane.Headline }}</span>
            </h4>

            <ng-container *ngIf="!isLaneCollapsed(lane.Id)">
                <button style="width: 100%" (click)="OpenAddTaskDialog()" mat-raised-button color="primary" *ngIf="ShowNewButton && i === 0">
                    <div style="width: 100%; display: flex">neue Aufgabe <fa-icon icon="plus" style="margin-left: auto"></fa-icon></div>
                </button>
                <div class="inner-wrapper" cdkDropList cdkDropListSortingDisabled [cdkDropListConnectedTo]="ExternalConnectedDropListIds" [cdkDropListDisabled]="DisableDragNDrop$ | async" [cdkDropListData]="lane.Id" (cdkDropListDropped)="Drop($event)">
                    <p class="no-items">keine Aufgaben vorhanden</p>
                    <app-event-card
                        *ngFor="let taskId of lane.eventIds$ | async"
                        [id]="taskId"
                        [cdkDragData]="taskId"
                        cdkDrag
                        (FileClicked)="FileClicked.emit($event)"
                        style="margin-top: 1rem; display: block;"
                        [EventId]="taskId"
                    >
                        <ng-container *ngIf="openedFromWeekPlan">
                            <ng-template cdkDragPreview [matchSize]="false">
                                <div
                                    class="week-plan-drag-preview"
                                    [style.background]="DragPreviewBackground || '#00897b'"
                                >
                                    <app-event-card
                                        [EventId]="taskId"
                                        [Expandable]="false"
                                        [Compact]="CompactEnum.Compact"
                                        [EventInWeekPlan]="true"
                                        style="display: block; width: 100%; height: 100%;"
                                    ></app-event-card>
                                </div>
                            </ng-template>
                        </ng-container>
                    </app-event-card>

                    <button app-button (click)="nextPage(lane.page$, 5)" *ngIf="(lane.isLastPage$ | async) === false">mehr laden</button>
                </div>
            </ng-container>
        </div>
    </ng-container>

</div>
